import React from 'react';
import {Link} from 'react-router-dom';
import {Alert,Container} from 'reactstrap';
import config from '../config';
import '../styles.css';
export default function Layout({title,error,children}){
 return <main className="page-content event-gap"><Container fluid>
 <div className="page-title-box d-sm-flex align-items-center justify-content-between"><h4 className="mb-sm-0">{title}</h4><div className="page-title-right"><ol className="breadcrumb m-0"><li className="breadcrumb-item"><Link to="/event-gap">{config.title}</Link></li><li className="breadcrumb-item active">{title}</li></ol></div></div>
 <p className="text-muted fs-11 mb-3">ForecastNest provides AI-generated market analysis and quantitative research for informational and educational purposes only. Nothing here constitutes financial, investment, legal, or tax advice. Conduct your own research and consult a licensed financial advisor before making investment decisions.</p>
 <nav className="d-flex flex-wrap gap-3 mb-3"><Link to="/event-gap">History</Link></nav>
 {error&&<Alert color="danger">{error}</Alert>}{children}
 </Container></main>;
}
